import React, { Component } from 'react';
import { PropTypes as MobxPropTypes, inject, observer } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import { Form, Input } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { Heading, ContainerBox } from '../AdminStyle';
import { instanceOf } from 'prop-types';
import { LogeButtonSlim } from '../../GeneralStyle'
import Parse from 'parse'
import config from 'react-global-configuration';
import ConfirmInvoiceResendModal from "../../internal/Modals/ConfirmInvoiceResendModal"

@inject("adminStore")

@observer
class InvoiceForm extends Component {
		constructor(props) {
			super(props)
			this.state = {
				invoice: this.props.invoice,
				isLoading: false,
				payedError: false,
				showTransition: false,
				cancelState: 0, // O: default, 1: loading, 2: error, 3: success
			}
		}

		componentDidUpdate(prevProps) {
			if (prevProps.invoice !== this.props.invoice)
				this.setState({ showTransition: false, invoice: this.props.invoice, cancelState: 0 })
		}

		payed = () => {
			this.setState({ isLoading: true })

			let InvoiceObject = Parse.Object.extend("Invoice");

			let query = new Parse.Query(InvoiceObject);
			query.get(this.props.invoice.objectId,
				{
					success: function (instance) {
						instance.set("isPaid", true)
						instance.save()
					},
					error: function (err) { }
				})
				.then(() => {
					this.setState({ isLoading: false, showTransition: true, invoice: {...this.state.invoice, isPaid: true} })
				})
				.catch(err => {
					console.error("err", err)
					this.payedError()
				})
		}

		payedError = () => {
			this.setState({ isLoading: false, payedError: true, invoice: {...this.state.invoice, isPaid: false}  })
			setTimeout(() => {
				this.setState({ payedError: false })
			}, 3 * 1000);
		}

		cancel = () => {
			this.setState({ cancelState: 1 })
			Parse.Cloud.run("createCancelInvoice", { invoiceId: this.state.invoice.objectId })
				.then(result => {
					this.setState({ cancelState: 0, invoice: {...this.state.invoice, gotRefunded: true} })
				})
				.catch(error => {
					console.error("error", error)
					this.setState({ cancelState: 2 })
				})
		}

		generate = () => {
			this.setState({ cancelState: 1 })
			Parse.Cloud.run("generateNewInvoice", { invoiceId: this.state.invoice.objectId })
				.then(result => {
					this.setState({ cancelState: 3, invoice: {...this.state.invoice, gotRefunded: true} })
					if(!result) return;
					this.props.history.push(`/`)
					this.props.history.push(`/internal/admin/invoices/${result}`);
				})
				.catch(error => {
					console.error("error", error)
					this.setState({ cancelState: 2 })
				})
		}

		render() {

				const invoice = this.state.invoice

				if(!(invoice && invoice.contract))
					return (
						<ContainerBox>
						<Row style={{ padding: 25, margin: 'auto' }}>
						<Col md={12} style={{textAlign: "center", color: "black"}}>
							Vertrag konnte nicht geladen werden
						</Col>
						</Row>
						</ContainerBox>
					)

				return (
						<div>
						<ContainerBox style={{maxWidth: 1200, margin: "20px auto"}}>
								<Row style={{ padding: 25, margin: 'auto' }}>
									<Heading style={{paddingLeft: 0, marginLeft: 37, display: "inline-block"}}>Rechnung: Nr. { invoice.invoiceNumber } </Heading>
									<div style={{ paddingLeft: 0, marginLeft: 37, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>

										<Form
												className={'dashboard-form'}
												layout={'vertical'}
												validateOnSubmit={false}
												validatePristine={false}
												formNoValidate
												noValidate
										>
											<Col md={6}>
												<Input
													name="invoiceNumber"
													label="Rechnungs Nummer"
													value={ invoice.invoiceNumber }
													type="text"
													disabled
													/>
											</Col>

											<Col md={6}>
												<Input
													name="invoiceObjectId"
													label="Rechnungs ID"
													value={ invoice.objectId }
													type="text"
													disabled
													/>
											</Col>

											<Col md={4}>
												<Input
													name="type"
													label="Typ"
													value={ invoice.isRefund ? "Gutschrift" : "Lastschrift" }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="contract"
													label="Vertrag"
													value={ invoice.contract.objectId }
													type="text"
													disabled
												/>
											</Col>

											<Col md={2} style={{ paddingTop: 35, paddingRight: 45 }}>
												<LogeButtonSlim
								          hoverFontColor={"white"}
													style={{width: "100%"}}
								          onClick={() => { this.props.history.push(`/internal/admin/contracts/${invoice.contract.objectId}`) }}>
								            anzeigen
								        </LogeButtonSlim>
											</Col>

											<Col md={6}>
												<Input
													name="sentstatus"
													label="Zustellstatus"
													value={invoice.isSent ? `Gesendet ✔ ${(invoice.reminderCount && invoice.reminderCount > 0) ? "(+"+invoice.reminderCount+" Erinnerungen)": "" }` : "Noch nicht gesendet ✘"}
													type="text"
													disabled
												/>
											</Col>
											<Col md={6}></Col>

											<Col md={invoice.isPaid || invoice.gotRefunded || invoice.isRefund ? 12 : 8} style={{transition: this.state.showTransition ? "width 0.5s ease-in-out" : "none"}}>
												<Input
													name="paymentstatus"
													label="Zahlungsstatus"
													value={ `${!invoice.gotRefunded ? ( invoice.isPaid ? "Bezahlt ✔" : "Zahlung ausstehend ✘") : "Storniert ✘"} (Betrag: ${invoice.amount} €)`}
													type="text"
													disabled
												/>
											</Col>

											{ ( !invoice.isPaid && !invoice.gotRefunded && !invoice.isRefund ) &&
												<div>
												<Col md={2} style={{ paddingTop: 35, paddingRight: 45}}>
													<LogeButtonSlim
														hoverFontColor={"white"}
														style={{width: "100%"}}
														onClick={() => { this.confirmResendModal.open() } }
														loading>
															Rechnungs Erinnerung senden
													</LogeButtonSlim>
												</Col>
												<Col md={2} style={{ paddingTop: 35, paddingRight: 45 }}>
													<LogeButtonSlim
									          hoverFontColor={"white"}
														style={{width: "100%"}}
									          onClick={ this.payed }>
															{this.state.isLoading ? "loading ..." : (this.state.payedError ? "Fehler" : "Zahlung bestätigen")}
									        </LogeButtonSlim>
												</Col>
												</div>
											}
											<Col md={12} style={{ textAlign: "left", paddingLeft: 35, paddingRight: 35}}>
												<LogeButtonSlim
													hoverFontColor={"white"}
													onClick={() => { window.open(config.get('CLOUDINARY_URL') + invoice.url, "_blank") }}>
														Rechnung anzeigen
												</LogeButtonSlim>
												{ !invoice.isRefund && !invoice.gotRefunded &&
													<LogeButtonSlim
														hoverFontColor={"white"}
														onClick={ this.cancel }
														disabled={this.state.cancelState === 0 || this.state.cancelState === 2 ? false : true }
														style={{ backgroundColor: 'rgb(217, 83, 79)', border: "none"}}
													>
														<p style={{color: "white", margin: 0}}>{ this.state.cancelState === 0 ? "Rechnung stornieren" : this.state.cancelState === 1 ? "Laden ..." : this.state.cancelState === 2 ? "Stornierungsfehler" : "Erfolgreich storniert" }</p>
													</LogeButtonSlim>
												}
												{ !invoice.isRefund && invoice.gotRefunded &&
													<LogeButtonSlim
														hoverFontColor={"white"}
														onClick={ this.generate }
														disabled={this.state.cancelState === 0 || this.state.cancelState === 2 ? false : true }
													>
														{ this.state.cancelState === 0 ? "Rechnung neu generieren" : this.state.cancelState === 1 ? "Laden ..." : this.state.cancelState === 2 ? "Generierungsfehler" : "Erfolgreich generiert" }
													</LogeButtonSlim>
												}
											</Col>

											<Col md={12} style={{ textAlign: "center" }}>
												<LogeButtonSlim
								          hoverFontColor={"white"}
								          onClick={() => { this.props.history.push(`/internal/admin/invoices/`) }}>
								            zurück zur Liste
								        </LogeButtonSlim>
											</Col>
										</Form>

								</Row>
								</ContainerBox>
								<ConfirmInvoiceResendModal
									invoice={invoice}
									onResend={() => {
										// this.props.adminStore.sendInvoiceReminderMail(invoice.objectId);
										this.setState({invoice: {...this.state.invoice, reminderCount: this.state.invoice.reminderCount + 1}});
									}}
									ref={instance => { this.confirmResendModal = instance; }}/>
						</div>
				);
		}
}

InvoiceForm.propTypes = {
		userStore: MobxPropTypes.observableObject,
		cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(InvoiceForm));



// WEBPACK FOOTER //
// /src/components/admin/Forms/InvoiceForm.js